import React from 'react'
import SideBar from './SideBar'

function DashboardLayout({children}) {
    return (
        <div className='dashboard-wrapper'>
            <SideBar/>
            <div className='main-content'>
                <div className='content-area'>
                    {children}
                </div>
            </div>
        </div>
    )
}

export default DashboardLayout
